/**
 * Single source of truth for the TrustArc DOM contract.
 *
 * These ids and class names are shared across several independent consumers:
 * - `index.html` declares the container/banner elements
 * - `src/styles/trustarc.css` gates banner visibility on `geo-verified`
 * - `src/trustarcCustomCSS.ts` applies `geo-verified` / `trustarc-us` once geo resolves
 * - `src/utils/trustArc/trustArcPlaceholder.ts` waits for that gate before releasing
 *   its reserved space
 *
 * Keeping them here prevents the values from drifting apart: renaming `geo-verified` in
 * only one place would silently leave the placeholder reserved until its fallback timeout.
 * Any change here must be mirrored in `index.html` and `trustarc.css`.
 */

export const TRUSTARC_CONTAINER_ID = 'trustarc_container';
export const TRUSTARC_BANNER_ID = 'consent-banner';

/** Added to the container once the visitor's geo is resolved; reveals `#consent-banner`. */
export const TRUSTARC_GEO_VERIFIED_CLASS = 'geo-verified';

/** Added to the container for US visitors to apply the US-specific banner styling. */
export const TRUSTARC_US_CLASS = 'trustarc-us';
